/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useContext} from "react";

import {useDispatch} from "react-redux";
import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";
import {LOG_USER_OUT_ACTION} from "@Actions/Authentication";

import APPLICATION_ROUTER_INTERFACE from "@ROUTER/Interfaces/Router";
import ApplicationRouterContext from "@Contexts/Router";

import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";


import {NavLink, Redirect} from "react-router-dom";


import {Col, Row} from "react-bootstrap";


import ApplicationHeaderComponent from "@UIParts/Header";


import BlockContentContainerComponent from "@Components/UI/Containers/Block";


type SettingsPageHomeViewProps = {};


export const SettingsPageHomeViewComponent: React.FC<SettingsPageHomeViewProps> = (): JSX.Element | null => {


    const DISPATCHER = useDispatch();


    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state):ReturnType<any> => state?.authentication
    )?.loggedUser || null;


    const ROUTER: APPLICATION_ROUTER_INTERFACE = useContext(ApplicationRouterContext);


    if (!LOGGED_USER || !LOGGED_USER?.userID) <Redirect to={ROUTER.NOT_AUTHENTICATED.LOGIN.URL} />;


    if (!ROUTER) return <Redirect to={"/404"} />;


    const SETTINGS_PAGE_URLS = ROUTER.AUTHENTICATED.SETTINGS;

    const {
        SETTINGS_USER_DATA_PAGE, SETTINGS_MY_DOCUMENTS_PAGE, SETTINGS_MY_BHP_PAGE, SETTINGS_FINISHED_TRANSPORTS_PAGE,
        SETTINGS_MY_FAVORITE_VEHICLES_PAGE, SETTINGS_MY_FAVORITE_TERMINALS_PAGE,
        SETTINGS_DELETE_ACCOUNT_PAGE, SETTINGS_CHANGE_PASSWORD_PAGE,
        SETTINGS_REGULATIONS_PAGE, SETTINGS_CONTACT_PAGE, SETTINGS_ABOUT_PAGE, SETTINGS_DISCONNECT_FROM_OPERATOR_PAGE
    } = SETTINGS_PAGE_URLS;


    return (
        <BlockContentContainerComponent cssClasses={"settings-page-main-view-component"}>

            <ApplicationHeaderComponent cssClasses={"settings-page-application-header"} />

            <Col xs={12} className={"settings-page-sub-sites"}>

                <Row className={"settings-page-sub-sites-group"}>
                    <Col xs={12} className={"settings-page-sub-site"}>
                        <NavLink to={SETTINGS_USER_DATA_PAGE.URL} title={`Moje dane`} className={"settings-page-sub-site-link"}>
                            <span>{`Moje dane`}</span>
                        </NavLink>
                    </Col>
                    <Col xs={12} className={"settings-page-sub-site"}>
                        <NavLink to={SETTINGS_MY_DOCUMENTS_PAGE.URL} title={`Moje dokumenty`} className={"settings-page-sub-site-link"}>
                            <span>{`Moje dokumenty`}</span>
                        </NavLink>
                    </Col>
                    <Col xs={12} className={"settings-page-sub-site"}>
                        <NavLink to={SETTINGS_MY_BHP_PAGE.MAIN_PAGE.URL} title={`Moje szkolenia BHP`} className={"settings-page-sub-site-link"}>
                            <span>{`Moje szkolenia BHP`}</span>
                        </NavLink>
                    </Col>
                    <Col xs={12} className={"settings-page-sub-site"}>
                        <NavLink to={SETTINGS_FINISHED_TRANSPORTS_PAGE.URL} title={`Moje zakończone transporty`} className={"settings-page-sub-site-link"}>
                            <span>{`Moje zakończone transporty`}</span>
                        </NavLink>
                    </Col>
                </Row>

                <Row className={"settings-page-sub-sites-group"}>
                    <Col xs={12} className={"settings-page-sub-site"}>
                        <NavLink to={SETTINGS_MY_FAVORITE_VEHICLES_PAGE.URL} title={`Moje ulubione pojazdy`} className={"settings-page-sub-site-link"}>
                            <span>{`Moje ulubione pojazdy`}</span>
                        </NavLink>
                    </Col>
                    <Col xs={12} className={"settings-page-sub-site"}>
                        <NavLink to={SETTINGS_MY_FAVORITE_TERMINALS_PAGE.URL} title={`Moje ulubione bazy paliw`} className={"settings-page-sub-site-link"}>
                            <span>{`Moje ulubione bazy paliw`}</span>
                        </NavLink>
                    </Col>
                </Row>

                <Row className={"settings-page-sub-sites-group"}>
                    <Col xs={12} className={"settings-page-sub-site"}>
                        <NavLink to={SETTINGS_DELETE_ACCOUNT_PAGE.URL} title={`Usuń konto`} className={"settings-page-sub-site-link"}>
                            <span>{`Usuń konto`}</span>
                        </NavLink>
                    </Col>
                    <Col xs={12} className={"settings-page-sub-site"}>
                        <NavLink to={SETTINGS_CHANGE_PASSWORD_PAGE.URL} title={`Zmień hasło`} className={"settings-page-sub-site-link"}>
                            <span>{`Zmień hasło`}</span>
                        </NavLink>
                    </Col>
                    <Col xs={12} className={"settings-page-sub-site"}>
                        <NavLink to={SETTINGS_DISCONNECT_FROM_OPERATOR_PAGE.URL} title={`Zgłoś odłączenie od przewoźnika`} className={"settings-page-sub-site-link"}>
                            <span>{`Odłącz przewoźnika`}</span>
                        </NavLink>
                    </Col>
                </Row>

                <Row className={"settings-page-sub-sites-group"}>
                    <Col xs={12} className={"settings-page-sub-site"}>
                        <NavLink to={SETTINGS_REGULATIONS_PAGE.URL} title={`Regulaminy i klauzule`} className={"settings-page-sub-site-link"}>
                            <span>{`Regulaminy i klauzule`}</span>
                        </NavLink>
                    </Col>
                    <Col xs={12} className={"settings-page-sub-site"}>
                        <NavLink to={SETTINGS_CONTACT_PAGE.URL} title={`Kontakt`} className={"settings-page-sub-site-link"}>
                            <span>{`Kontakt`}</span>
                        </NavLink>
                    </Col>
                </Row>

                <Row className={"settings-page-sub-sites-group"}>
                    <Col xs={12} className={"settings-page-sub-site"}>
                        <NavLink to={SETTINGS_ABOUT_PAGE.URL} title={`O aplikacji`} className={"settings-page-sub-site-link"}>
                            <span>{`O aplikacji`}</span>
                        </NavLink>
                    </Col>
                </Row>

                <Row className={"settings-page-sub-sites-group"}>
                    <Col xs={12} className={"settings-page-sub-site"}>
                        <NavLink to={"/"} title={`Wyloguj się`} className={"settings-page-sub-site-link"} onClick={e => {e.preventDefault(); DISPATCHER(LOG_USER_OUT_ACTION())}}>
                            <span>{`Wyloguj się`}</span>
                        </NavLink>
                    </Col>
                </Row>

            </Col>

        </BlockContentContainerComponent>
    );

};


export default SettingsPageHomeViewComponent;
